// Aqui os dados do head das páginas

import React from 'react'
import Helmet from 'react-helmet'

interface Props {
  title?: string
  description?: string
  location?: Location
  schema?: object
}

const DEFAULT_TITLE = process.env.GATSBY_SITE_NAME
const DEFAULT_DESCRIPTION =
  'Você sempre de carro novo, conte com a Dimas Sempre para assinatura de veículos e terceirização de frota. Conheça nossos planos.'

const Head = ({ title, description, location, schema }: Props) => (
  <Helmet>
    <meta
      property="og:image"
      itemProp="image"
      content={`https://${process.env.GATSBY_SITE_URL}/opengraph.jpg`}
    />
    <meta
      name="twitter:image"
      content={`https://${process.env.GATSBY_SITE_URL}/opengraph.jpg`}
    />
    <title>{title || DEFAULT_TITLE}</title>
    <meta property="og:title" content={title || DEFAULT_TITLE} />
    <meta property="og:site_name" content={process.env.GATSBY_SITE_NAME} />
    <meta name="description" content={description || DEFAULT_DESCRIPTION} />
    <meta
      property="og:description"
      content={description || DEFAULT_DESCRIPTION}
    />
    <link
      rel="canonical"
      href={`https://${process.env.GATSBY_SITE_URL}${location?.pathname || ''}`}
    />
    <meta
      property="og:url"
      content={`https://${process.env.GATSBY_SITE_URL}${
        location?.pathname || ''
      }`}
    />
    <link rel="shortcut icon" href="/favicon.ico?1" type="image/x-icon" />
    <meta property="og:locale" content="pt_BR" />
    <meta charSet="utf-8" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=no, maximum-scale=1.0"
    />
    {schema && (
      <script type="application/ld+json">
        {JSON.stringify(schema).replace(/</g, '\\u003c')}
      </script>
    )}
  </Helmet>
)

export default Head
